export CustomerIcon from '@material-ui/icons/Contacts'
export CustomerList from './List'
export CustomerShow from './Show'
export CustomerCreate from './Create'
export CustomerEdit from './Edit'
export CustomerQueries from './queries'
